import React, { useContext, useEffect, useState } from 'react';
// @ts-ignore
import * as styles from './tally.module.css';
import Cookies from 'js-cookie';
import { getIpLocation } from '../../utils/ipLocation';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';

export interface Props {
    formUrl: string;
}

const referrers = [
    'google',
    'facebook',
    'youtube',
    'bing',
    'yahoo',
    'duckduckgo',
];

const Tally: React.FC<Props> = ({ formUrl }) => {
    const pageContext = useContext(PageMetadataContext);
    const [iframeUrl, setIframeUrl] = useState('');
    const [ipLoaded, setIpLoaded] = useState(false);

    if (!formUrl) return null;

    const doc = typeof document !== 'undefined' ? document : null;

    const cookie: Record<string, string> = doc
        ? doc.cookie.split('; ').reduce((acc, item) => {
              const [k, ...v] = item.split('=');
              acc[k] = v.join('=');
              return acc;
          }, {} as Record<string, string>)
        : {};

    const pageParams =
        typeof window !== 'undefined'
            ? new URLSearchParams(window.location.search)
            : new URLSearchParams();

    const getFromUrlOrCookie = (urlKey: string, cookieKey: string) =>
        pageParams.get(urlKey) || cookie[cookieKey] || '';

    const getPathFromUrl = (url: string) => url.split(/[?#]/)[0];

    const isUK = pageContext?.preferredLanguage?.toLowerCase() === 'gb-en';

    let uSource = getFromUrlOrCookie('utm_source', '_uc_utm_source');
    let uMedium = getFromUrlOrCookie('utm_medium', '_uc_utm_medium');
    let uCampaign = getFromUrlOrCookie('utm_campaign', '_uc_utm_campaign');
    let uContent = getFromUrlOrCookie('utm_content', '_uc_utm_content');

    let ireferrer = cookie['_uc_referrer'];
    let lreferrer = cookie['_uc_last_referrer'];
    let ilandpage = cookie['_uc_initial_landing_page'];
    let visits = cookie['_uc_visits'];

    let marketingChannel = '';
    let leadSource = '';
    let referrer = '';

    const leadSourceFromUrl = pageParams.get('leadsource');

    if (uSource) {
        if (uMedium?.toLowerCase() === 'partner') {
            [uSource, uMedium] = [uMedium, uSource];
        }
        marketingChannel = uSource;
        leadSource = leadSourceFromUrl || uMedium;
    } else if (ireferrer) {
        referrer = referrers.find((r) => ireferrer.includes(r)) || ireferrer;

        marketingChannel = referrer;
        leadSource = ireferrer === 'direct' ? 'Direct' : 'organic';
    }

    useEffect(() => {
        const buildIframeUrl = async () => {
            try {
                const ipData = await getIpLocation();
                const params = new URLSearchParams();

                const set = (k: string, v?: string) => {
                    if (v && v !== 'null' && v !== 'undefined')
                        params.set(k, v);
                };

                set('USOURCE', uSource);
                set('leadSourceweb', leadSource?.substring(0, 37));
                set('marketingChannel', marketingChannel?.substring(0, 40));
                set('referrer', referrer);
                set('umedium', uMedium);
                set('ucampaign', uCampaign);
                set('ireferrer', ireferrer?.substring(0, 255));
                set('lreferrer', lreferrer?.substring(0, 255));
                set(
                    'ilandpage',
                    decodeURIComponent(ilandpage || '').substring(0, 255)
                );
                set('visits', visits);
                set('ucontent', uContent);
                set('ipAddress', ipData?.ip);
                set('swPage', getPathFromUrl(window.location.href));
                set('swObject', Cookies.get('sw') ?? '');
                set('cid', Cookies.get('_ga') ?? '');
                set('partnerkey', Cookies.get('growSumoPartnerKey') ?? '');
                set(
                    'mbsy',
                    pageParams.get('mbsy') ?? Cookies.get('promocode') ?? ''
                );
                const gclidFromIlandpage = (() => {
                    try {
                        const url = new URL(
                            ilandpage || '',
                            window.location.origin
                        );
                        return url.searchParams.get('gclid') || '';
                    } catch {
                        return '';
                    }
                })();
                set(
                    'gclid',
                    pageParams.get('gclid') ??
                        Cookies.get('gclid') ??
                        gclidFromIlandpage
                );
                set(
                    'gbraid',
                    pageParams.get('gbraid') ?? Cookies.get('gbraid') ?? ''
                );
                set(
                    'wbraid',
                    pageParams.get('wbraid') ?? Cookies.get('wbraid') ?? ''
                );
                set(
                    'msclkid',
                    pageParams.get('msclkid') ?? Cookies.get('msclkid') ?? ''
                );
                set(
                    'fbclid',
                    pageParams.get('fbclid') ?? Cookies.get('fbclid') ?? ''
                );
                set('_uc_utm_term', Cookies.get('_uc_utm_term') ?? '');
                set(
                    'ABTasty',
                    Cookies.get('ABTasty')?.replace(/&/g, '$$') ?? ''
                );
                if (isUK) {
                    set('clickId', Cookies.get('im_ref') ?? '');
                }

                const finalUrl = formUrl.includes('?')
                    ? `${formUrl}&${params.toString()}`
                    : `${formUrl}?${params.toString()}`;

                setIframeUrl(finalUrl);
                setIpLoaded(true);
            } catch (err) {
                console.error(err);
                setIframeUrl(formUrl);
                setIpLoaded(true);
            }
        };

        buildIframeUrl();
    }, []);

    if (!ipLoaded || !iframeUrl) {
        return (
            <div
                className={styles.tallyIframe}
                aria-busy="true"
                aria-label="Loading form"
            />
        );
    }

    return (
        <div className={styles.tallyIframe}>
            <iframe
                src={iframeUrl}
                width="100%"
                height="100%"
                title="Tally Form"
            />
        </div>
    );
};

export default Tally;
